import { ConfigProvider, theme } from "antd";
import React, { useEffect, useMemo } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Layouts from "./components/common/Layout";

import { routeConfig } from "./utils/routeConfig";
import { useAuth } from "./utils/store";

const withLayout = (Component, props = {}) => {
  return (componentProps) => (
    <Layouts>
      <Component {...componentProps} {...props} />
    </Layouts>
  );
};

const antdTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: "#c48c45",
    borderRadius: 4,
  },
  components: {
    Table: {
      headerBg: "#f0f2f5",
      headerColor: "#262626",
      rowHoverBg: "#f5f5f5",
    },
  },
};

const LoadingFallback = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    Loading...
  </div>
);

const App = () => {
  const user = useAuth((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user && location.pathname !== "/login") {
      navigate("/login");
    } else if (user && location.pathname === "/login") {
      navigate("/");
    }
  }, [user, navigate, location.pathname]);

  const routes = useMemo(
    () =>
      routeConfig.flatMap(({ routes }) =>
        routes.map(({ path, component: Component, layoutWrapper, props }) => (
          <Route
            key={path}
            path={path}
            element={
              layoutWrapper ? (
                withLayout(Component, props)({})
              ) : (
                <Component {...props} />
              )
            }
          />
        ))
      ),
    []
  );

  return (
    <ConfigProvider theme={antdTheme}>
      <React.Suspense fallback={<LoadingFallback />}>
        <Routes>{routes}</Routes>
      </React.Suspense>
    </ConfigProvider>
  );
};

export default App;
